import { Route, Routes } from "react-router-dom";
import TitlePage from "../pages/TitlePage";
import { lazy, memo, Suspense } from "react";


const MapPage = lazy(()=> import('../pages/MapPage'));
const MainPage = lazy(()=> import('../pages/MainPage'));
const CaracterPage = lazy(()=> import('../pages/CaracterPage'));
const CollectionsPage = lazy(()=> import('../pages/CollectionsPage'));
const BonusPage = lazy(()=>import('../pages/BonusPage'));
const LeadersPage = lazy(()=>import('../pages/LeadersPage'));
const MissionsPage = lazy(()=>import('../pages/MissionsPage'));
const TransactionsPage = lazy(() =>import('../pages/TransactionsPage'));
const AchievementsPage = lazy(() =>import('../pages/AchievementsPage'));

const publicRoutes:any[]=[
    {
      path:"/",
      Component: <TitlePage/>
    },
    {
      path:'/MainPage',
      Component:<Suspense fallback={<></>}><MainPage/></Suspense>
    },
    {
      path:'/CaracterPage/:id',
      Component: <Suspense fallback={<></>}><CaracterPage/></Suspense>
    },
    {
      path:'/CollectionsPage',
      Component: <Suspense fallback={<></>}><CollectionsPage/></Suspense>
    },
    {
      path:'/MapPage',
      Component:<Suspense fallback={<></>}><MapPage/></Suspense>
    },
    {
      path:'/LeadersPage',
      Component:<Suspense fallback={<></>}><LeadersPage/></Suspense>
    },
    {
      path:'/MissionsPage',
      Component:<Suspense fallback={<></>}><MissionsPage/></Suspense>
    },
    {
      path:'/BonusPage',
      Component:<Suspense fallback={<></>}><BonusPage/></Suspense>
    },
    {
      path:'/TransactionsPage',
      Component:<Suspense fallback={<></>}><TransactionsPage/></Suspense>
    },
    {
      path:'/AchievementsPage',
      Component:<Suspense fallback={<></>}><AchievementsPage/></Suspense>
    }
];
const AppRouter = () => {
  return (
    <Routes>
      {publicRoutes.map(({path, Component}) =>
        <Route key={path} path={path} element={Component}/>
      )}
      <Route path='*' element={<TitlePage/>}/>
    </Routes>
  )
}

export default memo(AppRouter);